<template>
  <div style="margin-bottom: 100px" class="home">
    <transition name="slide-y-transition">
      <l-alert :close="close" :text="text" v-if="show"></l-alert>
    </transition>
    <!-- for sending notifications 
    <transition name="slide-y-transition">
      <l-alert
        style="z-index: 9999999"
        :close="close"
        :text="payload.notification.title"
        v-if="payload !== ''"
      ></l-alert>
    </transition>-->

  <l-oyen v-if="!currentUser"></l-oyen>
    <transition name="company">
      <div class="center-me" v-if="!currentUser">
        <div
          style="margin-top: 30px; background: #FFBD2E; display: flex; justify-content: center"
          class="btn shadow_y"
          @click="$router.push({name: 'login'})"
        >
          <p style="color: #fff !important; margin: 0; line-height: 2.6; font-size: 1rem;" class="btn-text">
            <b>Login</b>
          </p>
        </div>
      </div>
      <div v-else>


        <draggable v-if="newState" class="container" @end="checkMove">
          <l-card
            v-for="card in filterCards"
            :key="card.uuid"
            :data="card"
            @open-card="openCard($event)"
          ></l-card>
        </draggable>

        <div v-else class="container">
          <v-flex md6 offset-md3 lg4 offset-lg4>
            <l-width-card
              v-for="card in filterCards"
              :key="card.uuid"
              :data="card"
              @open-card="openCard($event)"
            ></l-width-card>
          </v-flex>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import lCard from "@/components/card";
import lWidthCard from "@/components/widthCards";
import lAlert from "@/components/alert";
import lOyen from "@/components/oyen";
import lModal from "@/components/modal";
import lNo from "@/components/no";
import draggable from "vuedraggable";
import firebase from "firebase/app";
import "firebase/messaging";
import { firestore } from "@/firebase/async-firestore";
import "firebase/firestore";

const arrayMove = require("array-move");

export default {
  name: "home",
  components: {
    lCard,
    lAlert,
    lOyen,
    lModal,
    lNo,
    draggable,
    lWidthCard
  },
  data() {
    return {
      text: "You need at least one card",
      show: false,
      modal: false,
      payload: "",
      env: null,
      value: 0,
      text: "Delete all cards?",
      deleteCard: false,
      noCards: 'You do not have any tasks yet',
      standart: true,
      newState: true,
      allProducts: [],
    };
  },
  computed: {
    ...mapState("posts", ["products"]),
    ...mapState("user", ["currentUser", "state"]),
    ...mapGetters("posts", ["filterPosts"]),
    filterCards() {
      return this.products.sort(
        (a, b) => new Number(a.position) - new Number(b.position)
      );
    }
  },
  mounted () {
    firebase.firestore()
    .collection('users')
    .doc(this.currentUser.uid)
    .onSnapshot((doc) => {
        this.newState = doc.data().state;
    });
  },
  methods: {
    getData () {
      firebase.firestore()
      .collection('users')
      .doc(this.currentUser.uid)
      .collection("products")
      .get()
      .then((doc) => {
        doc.forEach((doc) => {
          this.allProducts = doc.data()
        });
      });
    },
    deleteCards() {
      this.deleteCard = true;
    },
   async checkMove(event) {
      const oldIndex = event.oldIndex;
      const newIndex = event.newIndex;
      var vm = this;

      const newArray = arrayMove(vm.products, oldIndex, newIndex);
      console.log(newArray)
      this.$store.commit("posts/SET_PRODUCTS", [])
        
     await newArray.forEach(async ele => {
         var selectedContent = newArray.indexOf(ele)
         var path = 'position'
         var uuid = ele.uuid
         var full = newArray

         await this.$store.state.posts.products.push({
           active: ele.active,
           createTimestamp: ele.createTimestamp,
           desc: ele.desc,
           id: ele.id,
           name: ele.name,
           position: newArray.indexOf(ele),
           priority: ele.priority,
           updateTimestamp: ele.updateTimestamp,
           uuid: ele.uuid,
           view: ele.view,
           website: ele.website
         })

         this.$store.dispatch("posts/triggerUpdateDesk", {
           selectedContent,
           path,
           uuid,
           full
         })

        await console.log(this.products)
        
      });     
    },
    close() {
      this.show = false;
    },
    openCard(event) {
      if (event.active === true) {
        var selectedContent = false;
      } else {
        var selectedContent = true;
      }
      const newData = {
        name: event.name,
        desc: event.desc,
        active: selectedContent,
        view: event.view,
        priority: event.priority,
        uuid: event.uuid
      };
      const path = "active";
      const uuid = event.uuid;
      this.$store.dispatch("posts/triggerAddProductActionActivity", {
        selectedContent,
        path,
        uuid,
        newData
      });
    },
  },
  //mounted() {
  //if app is in foreground
  //firebase.messaging().onMessage(payload => {
  //this.payload = payload;
  //});
  //}
};
</script>

<style>

.container {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 900px;
  margin: 0 auto;
}

.aspect-ratio {
  position: relative;
  height: 0;
  padding-bottom: 100%;
}

.home {
  height: 100%;
  background: #000; /*2c3e50*/
}
</style>